import { LoginInProgressAuthError } from '@ms/yammer-web-authenticators';

type IsPermanentFailure = (error: unknown) => boolean;
export const isPermanentFailure: IsPermanentFailure = (error) => !(error instanceof LoginInProgressAuthError);
